import React from "react";
import Brokers from "./brokers";

export default function Insurance() {
  return <Brokers year={2022} />;
}
